// src/api/auth/login.js
import { LOCAL_API_URL, http } from "../base";

// 统一登录方法
async function baseLogin(credentials) {

  console.log("baseLogin：",credentials);
  console.log(LOCAL_API_URL)
  try {
    const response = await http.post(
      `${LOCAL_API_URL}/auth/login`,
      {
        username: credentials.username,
        password: credentials.password
      },
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    console.log(response.data);
    // 统一处理响应格式
    // 确保返回数据结构包含 refreshToken
    if (response.data && response.data.code === 200) {
      console.log("response.data.data.refreshToken", response.data.data.refreshToken);
      return {
        ...response.data,
        data: {
          ...response.data.data,
          refreshToken: response.data.data.refreshToken // 确保后端返回 refreshToken
        }
      }
    }

    throw new Error(response.data.message || '登录失败');
  } catch (error) {
    throw new Error(
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message) ||
      '网络错误，请稍后重试'
    );
  }
}

// 登录
export const login = (credentials) =>
  baseLogin(credentials);




export const login_sms = (credentials) =>
  baseLogin_sms(credentials);

async function baseLogin_sms(credentials) {
  console.log("baseLogin_sms：", credentials);

  try {
    const response = await http.post(
      `/auth/login_sms`,
      {
        phone: credentials.phone,
        code: credentials.code
      },
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );

    console.log('短信登录响应:', response.data);

    // 确保返回完整的数据结构
    if (response.data && response.data.code === 200) {
      const responseData = response.data.data;

      console.log('refreshToken in response:', responseData.refreshToken);

      // 直接返回整个response.data，确保结构一致
      return response.data;
    } else {
      // 非200状态码，直接返回
      return response.data;
    }

  } catch (error) {
    console.error('短信登录失败:', error);
    throw new Error(
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message) ||
      '网络错误，请稍后重试'
    );
  }
}

/**
 * 获取图片验证码
 */
export const getImageCaptcha = () => {
  return http.get(`auth/captcha/image`);
};

/**
 * 密码登录（带验证码）
 */
export const loginWithCaptcha = (credentials, captchaId, captchaAnswer) => {
  console.log("登录参数:", { credentials, captchaId, captchaAnswer });
  
  // 构建查询参数
  let url = `/auth/login`;
  const params = new URLSearchParams();
  
  if (captchaId) {
    params.append('captchaId', captchaId);
  }
  params.append('captchaAnswer', captchaAnswer);  
  
  const queryString = params.toString();
  if (queryString) {
    url += '?' + queryString;
  }

  return http.post(
    url,
    {
      username: credentials.username,
      password: credentials.password
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
};

/**
 * 获取微信登录二维码
 */
export const getWechatQrCode = () => {
  return http.get(`${LOCAL_API_URL}/auth/wechat/qrcode`);
};

/**
 * 检查微信扫码状态
 */
export const checkWechatStatus = (tempCode) => {
  return http.get(`${LOCAL_API_URL}/auth/wechat/check/${tempCode}`);
};

/**
 * 微信登录
 */
export const wechatLogin = (data) => {
  return http.post(`${LOCAL_API_URL}/auth/wechat/login`, data);
};